import React, { useRef, useState, useEffect } from 'react';
import { useField } from '@rocketseat/unform';
import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';

export default function CustomCheckBox({
  label,
  name,
  valor,
  onChange,
  color,
}) {
  const ref = useRef(null);
  const { fieldName, registerField } = useField(name);
  const [valueX, setValueX] = useState(valor);

  useEffect(() => {
    if (ref.current) {
      registerField({
        name: fieldName,
        ref: ref.current.childNodes[0].childNodes[0].childNodes[0],
        path: 'value',
        clearValue: () => {
          setValueX(false);
        },
      });
    }
  }, [ref.current, fieldName]); //eslint-disable-line

  return (
    <FormControlLabel
      control={
        <Checkbox
          onChange={() => {
            setValueX(!valor);
            onChange(!valor);
          }}
          value={valor !== null ? valor : valueX}
          color={color}
          checked={valor}
        />
      }
      name={name}
      label={label}
      ref={ref}
    />
  );
}

CustomCheckBox.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  valor: PropTypes.bool,
  onChange: PropTypes.func,
  color: PropTypes.string,
};

CustomCheckBox.defaultProps = {
  valor: false,
  onChange: () => {
    return false;
  },
  color: 'primary',
};
